import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Store from '../../lib/stores/store';
import Instance from './instance.html';
import About from './edit-about';
import Save from '../../lib/components/save/save';
import BaSpinner from '../../lib/components/spinner/spinner';

Vue.use(Vuelidate);

if (document.getElementById('biosAdminEditAbout')) {
	const vue = new Vue({
		el: '#biosAdminEditAbout',
		store: Store,
		template: Instance,
		components: {
			About,
			BaSpinner,
			Save,
		},
	});
}
